import {KTCard} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'

import {useEffect, useMemo, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useFormContext} from 'react-hook-form'
import {Column} from 'react-table'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useModules} from '../../../../../../features/hoteleria/hooks/useModules'
import {useClients} from '../../../../hooks/central/useClients'
import {useCompanies} from '../../../../hooks/central/useCompanies'
import {useSites} from '../../../../hooks/central/useSites'
import {useAssigment} from '../../../../hooks/limpieza/useAssigment'
import {CreateScheduleAssigmentModel} from '../../../../model/assigment.model'
import {CREATION_CELLPHONES_SERVICES} from '../../../../services'
import {createScheduleAssigment} from '../../../../services/assigment.services'
import {CREATION_CLEANING_ACTIVITIES_SERVICES} from '../../../../services/creation-cleaning-activities.service'
import {TotalComponentWrapper} from '../components/TotalComponentWrapper'

interface ICampamento {
  CampamentoId: string
  CampamentoNombre: string
  TotalModulos?: number | 0
  TotalHabitaciones?: number | 0
  TotalCelulares?: number | 0
  TotalActividades?: number | 0
}

interface ICelular {
  Id: string
  NumeroCelular: string
  ProveedorServicio: string
  Modelo: string
  Marca: string
  Serie: string
  CampamentoId?: string | ''
  CampamentoNombre?: string | ''
}

interface IActividad {
  Id: string
  TiempoEstimado: string
  Orden: number
  TipoAccion: string
  ModuloId: string
  HabitacionId: string
  CamaId: string
  CampamentoId?: string | ''
  CampamentoNombre?: string | ''
}

const TableAssignmentCleaningSchedules = () => {
  const {loading, selected, clearSelected} = useKTable()
  const {setError, setValue, watch} = useFormContext()

  const {getCompanies, companies, clearCompanies} = useCompanies()
  const {getClients, clients, clearClients} = useClients()
  const {getSites, sites, clearSites} = useSites()
  const {getTypeBuildings} = useModules()

  const {
    tipoData,
    setTipoData,
    loading: isLoading,
    layout,
    setLayout,
    getLayout,
    setSelectedSchedulesFn,
  } = useAssigment()
  const [typeBuildings, setTypeBuildings] = useState<any[]>([])

  const handleGetTypeBuildings = async () => {
    const data = await getTypeBuildings()
    setTypeBuildings(data)
  }

  useEffect(() => {
    getCompanies({isCombo: true}, 1)
    handleGetTypeBuildings()
    handleListarActividadesDisponibles()
    // handleListarCelularesDisponibles()
    return () => {
      clearCompanies()
      clearClients()
      clearSites()
      setTypeBuildings([])
    }
  }, [])

  useEffect(() => {
    if (companies.length === 1) {
      setValue('CompaniaId', companies[0].value)
      setError('CompaniaId', {})
      getClients({isCombo: true, companiaId: companies[0].value}, 1)
    }
  }, [companies])

  useEffect(() => {
    if (clients.length === 1) {
      setValue('ClienteId', clients[0].value)
      setError('ClienteId', {})
      getSites({isCombo: true, clienteId: clients[0].value}, 1)
    }
  }, [clients])

  useEffect(() => {
    if (sites.length === 1) {
      setValue('SiteId', sites[0].value)
      setError('SiteId', {})
    }
  }, [sites])

  useEffect(() => {
    if (typeBuildings.length === 1) {
      setValue('TipoEdificacionId', typeBuildings[0].value)
      setError('TipoEdificacionId', {})
    }
  }, [typeBuildings])

  const [selectedOption, setSelectedOption] = useState<Record<string, string>>({})
  const [selectedOptionName, setSelectedOptionName] = useState<Record<string, string>>({})

  const [isLoadingLayout, setIsLoadingLayout] = useState(false)
  const [dataCampamentos, setDataCampamentos] = useState<ICampamento[]>([
    {CampamentoId: '1', CampamentoNombre: 'Campamento A'},
    {CampamentoId: '2', CampamentoNombre: 'Campamento B'},
  ])
  const [dataCelular, setDataCelular] = useState<ICelular[]>([
    {
      Id: '1',
      NumeroCelular: '+51 974 123 456',
      ProveedorServicio: 'Claro',
      Modelo: 'A50',
      Marca: 'SAMSUNG',
      Serie: 'A50SAN',
    },
    // { Id: '2', NumeroCelular: '+51 974 123 457', ProveedorServicio: 'Movistar', Modelo: 'Mate X4', Marca: 'HUAWEI', Serie: 'MATX4H' },
  ])
  const [dataAddCelular, setDataAddCelular] = useState<ICelular[]>([
    {
      Id: '1',
      NumeroCelular: '+51 974 123 456',
      ProveedorServicio: 'Claro',
      Modelo: 'A50',
      Marca: 'SAMSUNG',
      Serie: 'A50SAN',
    },
    {
      Id: '2',
      NumeroCelular: '+51 974 123 457',
      ProveedorServicio: 'Movistar',
      Modelo: 'Mate X4',
      Marca: 'HUAWEI',
      Serie: 'MATX4H',
    },
  ])

  const [dataActividades, setDataActividades] = useState<IActividad[]>([
    {
      Id: '1',
      TiempoEstimado: '10 min',
      Orden: 1,
      TipoAccion: 'Inicio/Fin',
      ModuloId: 'MOD-1',
      HabitacionId: 'HAB-1',
      CamaId: 'CAM-1',
    },
  ])

  const [dataAddActividades, setDataAddActividades] = useState<IActividad[]>([
    {
      Id: '2',
      TiempoEstimado: '15 min',
      Orden: 2,
      TipoAccion: 'Inicio/Fin',
      ModuloId: 'MOD-2',
      HabitacionId: 'HAB-2',
      CamaId: 'CAM-2',
    },
    {
      Id: '3',
      TiempoEstimado: '20 min',
      Orden: 3,
      TipoAccion: 'Inicio/Fin',
      ModuloId: 'MOD-3',
      HabitacionId: 'HAB-3',
      CamaId: 'CAM-3',
    },
  ])

  const [showCelulares, setShowCelulares] = useState(false)
  const [showAddCelulares, setShowAddCelulares] = useState(false)
  const [selectedCelulares, setSelectedCelulares] = useState<any[]>([])

  const [showActividades, setShowActividades] = useState(false)
  const [showAddActividades, setShowAddActividades] = useState(false)

  const columnsCelular: Column<ICelular>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Marca' name={'Marca'} />,
        accessor: 'Marca',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Modelo' name={'Modelo'} />,
        accessor: 'Modelo',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Proveedor' name={'ProveedorServicio'} />
        ),
        accessor: 'ProveedorServicio',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Celular' name={'NumeroCelular'} />
        ),
        accessor: 'NumeroCelular',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Borrar' size='20px' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEliminarCelular(props.data[props.row.index].Id)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          </>
        ),
      },
    ],
    [dataCelular],
  )
  const columnsAddCelular: Column<ICelular>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => <KTableSelectionCell id={props.data[props.row.index].Id} />,
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Número' name={'NumeroCelular'} />
        ),
        accessor: 'NumeroCelular',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Celular' />,
        id: 'data',
        Cell: ({...props}) => (
          <>
            <div className='d-flex justify-content-center flex-shrink-0'>
              {props.data[props.row.index].Marca}: {props.data[props.row.index].Modelo} -{' '}
              {props.data[props.row.index].ProveedorServicio}
            </div>
          </>
        ),
      },
    ],
    [dataAddCelular],
  )
  const columnsActividades: Column<IActividad>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Orden' name={'Orden'} />,
        accessor: 'Orden',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Tiempo Estimado' name={'Tiempo Estimado'} />
        ),
        accessor: 'TiempoEstimado',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Tipo Acción' name={'TipoAccion'} />
        ),
        accessor: 'TipoAccion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='ModuloId' name={'ModuloId'} />,
        accessor: 'ModuloId',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='HabitacionId' name={'HabitacionId'} />
        ),
        accessor: 'HabitacionId',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='CamaId' name={'CamaId'} />,
        accessor: 'CamaId',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Borrar' size='20px' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEliminarActividad(props.data[props.row.index].Id)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          </>
        ),
      },
    ],
    [dataActividades],
  )
  const columnsAddActividades: Column<IActividad>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => <KTableSelectionCell id={props.data[props.row.index].Id} />,
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Orden' name={'Orden'} />,
        accessor: 'Orden',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Tiempo Estimado' name={'Tiempo Estimado'} />
        ),
        accessor: 'TiempoEstimado',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Tipo Acción' name={'TipoAccion'} />
        ),
        accessor: 'TipoAccion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='ModuloId' name={'ModuloId'} />,
        accessor: 'ModuloId',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='HabitacionId' name={'HabitacionId'} />
        ),
        accessor: 'HabitacionId',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='CamaId' name={'CamaId'} />,
        accessor: 'CamaId',
      },
    ],
    [dataAddActividades],
  )

  const handleEliminarCelular = (CelularId: string) => {
    setDataCelular((prev) => prev.filter((celular) => celular.Id !== CelularId))
  }

  const handleOpenAddCelulares = () => {
    setShowAddCelulares(true)
  }
  const handleCloseAddCelulares = () => {
    setShowAddCelulares(false)
  }
  const handleSaveAddCelulares = async () => {
    var filter = dataAddCelular.filter((a) => selected.some((b) => a.Id === b))
    setDataCelular((prev) => [...prev, ...filter])
    handleCloseAddCelulares()
  }

  const handleOpenCelulares = () => {
    setShowCelulares(true)
  }
  const handleCloseCelulares = () => {
    setShowCelulares(false)
  }
  const handleSaveCelulares = async () => {
    handleCloseCelulares()
  }

  const handleOpenActividades = () => {
    setShowActividades(true)
  }
  const handleCloseActividades = () => {
    setShowActividades(false)
  }
  const handleSaveActividades = async () => {
    handleCloseActividades()
  }
  const handleEliminarActividad = (ActividadId: string) => {
    setDataActividades((prev) => prev.filter((actividad) => actividad.Id !== ActividadId))
  }
  const handleOpenAddActividades = () => {
    setShowAddActividades(true)
  }
  const handleCloseAddActividades = () => {
    setShowAddActividades(false)
  }
  const handleSaveAddActividades = async () => {
    var filter = dataAddActividades.filter((a) => selected.some((b) => a.Id === b))
    setDataActividades((prev) => [...prev, ...filter])
    handleCloseAddActividades()
  }

  const handleAsignar = async (request: CreateScheduleAssigmentModel) => {
    try {
      var respuesta = await createScheduleAssigment(request)
    } catch (error) {
      console.error('ERROR => ', error)
    }
  }

  const handleListarCelularesDisponibles = async () => {
    const {data: response} = await CREATION_CELLPHONES_SERVICES.getCellphoneList({
      pageNumber: 1,
      size: 10,
      CompaniaId: '6sAN_m5YV6mLyTiJu536rRmbY94zm7wD', // 6sAN_m5YV6mLyTiJu536rRmbY94zm7wD
      ClienteId: '6sAN_m5YV6n3NIRCeD.p5B0lOhABw6LI', // 6sAN_m5YV6n3NIRCeD.p5B0lOhABw6LI
      SiteId: '6sAN_m5YV6kS1mGQ8hdYrpqov_GfDVJ_', // 6sAN_m5YV6kS1mGQ8hdYrpqov_GfDVJ_
      CampamentoId: null, // 6sAN_m5YV6nVvfikkbd*dfS2YAVNAUuB  --  6sAN_m5YV6mk°cau++sbckOE2f.LMcQ
    })
    if (!response.error) {
      console.log('LISTA => ', response)
    }
  }

  const handleListarActividadesDisponibles = async () => {
    const {data: response} = await CREATION_CLEANING_ACTIVITIES_SERVICES.getCleaningActivitiesList({
      pageNumber: 1,
      size: 10,
      CompaniaId: '6sAN_m5YV6mLyTiJu536rRmbY94zm7wD', // 6sAN_m5YV6mLyTiJu536rRmbY94zm7wD
      ClienteId: '6sAN_m5YV6n3NIRCeD.p5B0lOhABw6LI', // 6sAN_m5YV6n3NIRCeD.p5B0lOhABw6LI
      SiteId: '6sAN_m5YV6kS1mGQ8hdYrpqov_GfDVJ_', // 6sAN_m5YV6kS1mGQ8hdYrpqov_GfDVJ_
      CampamentoId: null, // 6sAN_m5YV6nVvfikkbd*dfS2YAVNAUuB  --  6sAN_m5YV6mk°cau++sbckOE2f.LMcQ
    })
    if (!response.error) {
      console.log('LISTA => ', response)
    }
  }

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setSelectedOption((prevState) => ({...prevState, company: val.value}))
    setSelectedOptionName((prevState) => ({...prevState, company: val.label}))
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    clearSites()
    setError('CompaniaId', {})
    clearClients()
    getClients({isCombo: true, companiaId: value}, 1)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setSelectedOption((prevState) => ({...prevState, client: val.value}))
    setSelectedOptionName((prevState) => ({...prevState, client: val.label}))
    setValue('ClienteId', value)
    setValue('SiteId', '')
    clearSites()
    setError('ClienteId', {})
    getSites({isCombo: true, clienteId: value}, 1)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setSelectedOption((prevState) => ({...prevState, site: val.value}))
    setSelectedOptionName((prevState) => ({...prevState, site: val.label}))
    setValue('SiteId', value)
    setError('SiteId', {})
  }

  const loadCampsLayout = () => {
    if (!watch('SiteIdCurrent')) return
    setSelectedOption({...selectedOption, camp: '', mod: '', hbt: ''})
    setSelectedOptionName({...selectedOptionName, camp: '', mod: '', hbt: ''})
    let TipoDataIn = 'CAP'
    setTipoData(TipoDataIn)
    setValue('TipoData', TipoDataIn)
    setSelectedSchedulesFn([])
    //
    setValue('CampamentoNombre', '')
    setValue('ModuloNombre', '')
    setValue('PisoNombre', '')
    setValue('HabitacionNombre', '')
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    setValue('PisoId', '')
    setValue('HabitacionId', '')
    //
    getLayout({
      TipoData: TipoDataIn,
      CompaniaId: watch('CompaniaIdCurrent'),
      ClienteId: watch('ClienteIdCurrent'),
      SiteId: watch('SiteIdCurrent'),
      TipoEdificacionId: watch('TipoEdificacionIdCurrent'),
    })
  }

  const loadModulesLayout = (campamentoId: any, name: any) => {
    let TipoDataIn = 'MOD'
    setTipoData(TipoDataIn)
    setValue('TipoData', TipoDataIn)
    setLayout([])
    // setModules([])
    setSelectedOption({...selectedOption, camp: campamentoId, mod: '', hbt: ''})
    setSelectedOptionName({...selectedOptionName, camp: name, mod: '', hbt: ''})
    setSelectedSchedulesFn([])
    //
    setValue('CampamentoNombre', name)
    setValue('ModuloNombre', '')
    setValue('PisoNombre', '')
    setValue('CampamentoId', campamentoId)
    setValue('ModuloId', '')
    setValue('PisoId', '')
    setValue('HabitacionId', '')
    //
    getLayout({
      TipoData: TipoDataIn,
      CompaniaId: watch('CompaniaIdCurrent'),
      ClienteId: watch('ClienteIdCurrent'),
      SiteId: watch('SiteIdCurrent'),
      CampamentoId: campamentoId || 'zVw7@qUywJA=',
      TipoEdificacionId: watch('TipoEdificacionIdCurrent'),
    })
  }

  const loadFloorsLayout = (moduloId: any, name: string) => {
    let TipoDataIn = 'PIS'
    setTipoData(TipoDataIn)
    setValue('TipoData', TipoDataIn)
    setLayout([])
    setSelectedOption({...selectedOption, mod: moduloId, pis: '', hbt: ''})
    setSelectedOptionName({...selectedOptionName, mod: name, pis: '', hbt: ''})
    setSelectedSchedulesFn([])
    //
    setValue('ModuloNombre', name)
    setValue('PisoNombre', '')
    setValue('ModuloId', moduloId)
    setValue('PisoId', '')
    setValue('HabitacionId', '')
    //
    getLayout({
      TipoData: TipoDataIn,
      CompaniaId: watch('CompaniaIdCurrent'),
      ClienteId: watch('ClienteIdCurrent'),
      SiteId: watch('SiteIdCurrent'),
      CampamentoId: watch('CampamentoId'),
      ModuloId: moduloId,
      TipoEdificacionId: watch('TipoEdificacionId'),
    })
  }

  const loadHabiationsLayout = (pisoId: any, name: string) => {
    let TipoDataIn = 'HAB'
    setTipoData(TipoDataIn)
    setValue('TipoData', TipoDataIn)
    setLayout([])
    setSelectedOption({...selectedOption, pis: pisoId, hbt: ''})
    setSelectedOptionName({...selectedOptionName, pis: name, hbt: ''})
    setSelectedSchedulesFn([])
    //
    setValue('PisoNombre', name)
    setValue('PisoId', pisoId)
    setValue('HabitacionId', '')
    //
    getLayout({
      TipoData: TipoDataIn,
      CompaniaId: watch('CompaniaIdCurrent'),
      ClienteId: watch('ClienteIdCurrent'),
      SiteId: watch('SiteIdCurrent'),
      CampamentoId: watch('CampamentoId'),
      ModuloId: watch('ModuloId'),
      PisoId: pisoId,
      TipoEdificacionId: watch('TipoEdificacionIdCurrent'),
    })
  }

  const [isReset, setIsReset] = useState(false)
  const [dataGroup, setDataGroup] = useState<any>([])

  return (
    <KTCard shadow className=''>
      <div className='d-flex row p-4'>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Compañia'
            name='CompaniaId'
            data={companies}
            onChangeValue={handleCompanyChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cliente'
            name='ClienteId'
            data={clients}
            onChangeValue={handleClientChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Site'
            name='SiteId'
            data={sites}
            onChangeValue={handleSiteChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo Edificación'
            name='TipoEdificacionId'
            data={typeBuildings}
            required
          />
        </div>
      </div>

      <TotalComponentWrapper
        setDataGroup={setDataGroup}
        setIsReset={setIsReset}
        isReset={isReset}
        dataGroup={dataGroup}
        handleOpenActividades={handleOpenActividades}
        handleOpenCelulares={handleOpenCelulares}
        handleAsignar={handleAsignar}
        data={layout}
        loadCampsLayout={loadCampsLayout}
        selectedOptionName={selectedOptionName}
        selectedOption={selectedOption}
        tipoData={tipoData}
        loadModulesLayout={loadModulesLayout}
        loadFloorsLayout={loadFloorsLayout}
        loadHabiationsLayout={loadHabiationsLayout}
        isLoadingLayout={isLoading}
      />

      <Modal
        className='modal fade'
        show={showCelulares}
        dialogClassName='modal-xl'
        aria-hidden='true'
        onHide={handleCloseCelulares}
        style={{zIndex: 1050}}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Celulares Asignados</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              onClick={handleCloseCelulares}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
            </div>
          </div>
          <div className='modal-body pt-2'>
            <form>
              <ButtonWrapper className=''>
                <Button label='Agregar Celular' onClick={handleOpenAddCelulares} />
              </ButtonWrapper>
              <KTable
                data={dataCelular}
                columns={columnsCelular as any}
                showPagination={false}
                showButtons={false}
              />
              {loading ? <KTableLoading title='Cargando...' /> : null}
              <div className='d-flex justify-content-center mb-3'>
                <button
                  type='button'
                  className='btn btn-light-primary me-5'
                  onClick={handleCloseCelulares}
                >
                  Cancelar
                </button>
                <button type='button' className='btn btn-primary' onClick={handleSaveCelulares}>
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        className='modal fade'
        show={showAddCelulares}
        dialogClassName='modal-lg'
        aria-hidden='true'
        onHide={handleCloseAddCelulares}
        backdrop='static'
        style={{zIndex: 1060}}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Programaciones Disponibles</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              onClick={handleCloseAddCelulares}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
            </div>
          </div>
          <div className='modal-body pt-2'>
            <form>
              <KTable
                data={dataAddCelular}
                columns={columnsAddCelular as any}
                showPagination={false}
              />
              {loading ? <KTableLoading title='Cargando...' /> : null}
              <div className='d-flex justify-content-center mb-3'>
                <button
                  type='button'
                  className='btn btn-light-primary me-5'
                  onClick={handleCloseAddCelulares}
                >
                  Cancelar
                </button>
                <button type='button' className='btn btn-primary' onClick={handleSaveAddCelulares}>
                  Agregar
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        className='modal fade'
        show={showActividades}
        dialogClassName='modal-xl'
        aria-hidden='true'
        onHide={handleCloseActividades}
        style={{zIndex: 1050}}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Actividades Asignadas</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              onClick={handleCloseActividades}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
            </div>
          </div>
          <div className='modal-body'>
            <form>
              <ButtonWrapper className=''>
                <Button label='Agregar Actividad' onClick={handleOpenAddActividades} />
              </ButtonWrapper>
              <KTable
                data={dataActividades}
                columns={columnsActividades as any}
                showPagination={false}
                showButtons={false}
              />
              {loading ? <KTableLoading title='Cargando...' /> : null}
              <div className='d-flex justify-content-center mb-3'>
                <button
                  type='button'
                  className='btn btn-light-primary me-5'
                  onClick={handleCloseActividades}
                >
                  Cancelar
                </button>
                <button type='button' className='btn btn-primary' onClick={handleSaveActividades}>
                  Guardar
                </button>
              </div>
            </form>
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </div>
        </div>
      </Modal>

      <Modal
        className='modal fade'
        show={showAddActividades}
        dialogClassName='modal-lg'
        aria-hidden='true'
        onHide={handleCloseAddActividades}
        backdrop='static'
        style={{zIndex: 1070}}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Actividades Disponibles</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              onClick={handleCloseAddActividades}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
            </div>
          </div>
          <div className='modal-body pt-2'>
            <form>
              <KTable
                data={dataAddActividades}
                columns={columnsAddActividades as any}
                showPagination={false}
              />
              {loading ? <KTableLoading title='Cargando...' /> : null}
              <div className='d-flex justify-content-center mb-3'>
                <button
                  type='button'
                  className='btn btn-light-primary me-5'
                  onClick={handleCloseAddActividades}
                >
                  Cancelar
                </button>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={handleSaveAddActividades}
                >
                  Agregar
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </KTCard>
  )
}

export const AssignmentCleaningSchedulesTable = () => {
  return (
    <KTableProvider>
      <TableAssignmentCleaningSchedules />
    </KTableProvider>
  )
}
